// extracted by mini-css-extract-plugin
export default {"back":"DetailsModalCommon_back__8HFrt"};